import * as React from 'react'
import styled from 'styled-components'

import Icon from '../../ui/Icon/Icon'
import { DefaultCloseButton } from '../../ui/Modal/Modal'
import SkaleIcon from '../../../assets/img/gamification/skale-icon-nov-14-2024-2.gif'

const StyledIconContainer = styled.div`
  width: 120px;
  height: 120px;
  right: 40px;
  bottom: 40px;
  position: fixed;
  cursor: pointer;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('${SkaleIcon}');
  display: ${props => (props.show ? 'block' : 'none')};

  &:after {
  content: '';
  position: absolute;
  bottom: 3px;
  left: 0;
  width: 100%;
  height: 30px;
  border-radius: 50%;
  z-index: -1;
  background: transparent;
  box-shadow: 0 20px 8px -10px rgba(0, 0, 0, 0.5);
} 
`

const CloseButton = styled(DefaultCloseButton)`
  width: 30px;
  height: 30px;
  top: -5px;
  right: 0;
  padding: 0;

  > svg {
    font-size: 20px;
  }
`
const StyledIcon = styled(Icon)``

const SpinAndWinIcon = ({ show, onClick, onClose, zIndex }) => {
  return (
    <StyledIconContainer
      id="spinAndWinIcon"
      show={show}
      onClick={e => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      <CloseButton
        zIndex={zIndex}
        onClick={e => {
          e.stopPropagation()
          onClose(e)
        }}
      >
        <StyledIcon name="x" />
      </CloseButton>
    </StyledIconContainer>
  )
}

export default SpinAndWinIcon
